import { render, staticRenderFns } from "./RoundedCancelIcon.vue?vue&type=template&id=d7fa2494&"
import script from "./RoundedCancelIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RoundedCancelIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports